// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:10px auto}@media only screen and (max-width:900px){#app{margin:5px;width:95%!important}}h1{text-align:center;line-height:35px;word-break:break-word}@media only screen and (max-width:400px){h1{font-size:1.2em!important}}", ""]);
// Exports
module.exports = exports;
